export default __webpack_public_path__ + "static/media/semFoto.871cd833.png";